import React from 'react';

const TechPage = () => {
  return (
    <div>
      <div className="Content-Wrap">
        <div className="Main-Content">
          <h1 className="App-Subtitle">Tech</h1>
          <p className="Summary">
            Languages: C#, JavaScript, Dart, Python, Java, Ruby, SQL, PHP, HTML,
            CSS.
          </p>
          <p className="Summary">
            Technologies: React, Flutter, Firebase, Hasura, GQL, Node.js,
            professional experience with GIT and other VCS platforms such as
            Gitlab and SourceTree.
          </p>
          <p className="Summary">
            {' '}
            One of my greatest technical strengths is my ability to learn new
            technologies quickly. I was able to learn the basics of Flutter and
            React within a couple of days and became confident in both within a
            week.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TechPage;
